module.exports = __webpack_public_path__ + "img/ae-gif-5.374db13.gif";